export enum ETables {
  Packages = 'packages',
  PurchasedPackages = 'purchasedPackages',
  Customers = 'customers',
  Places = 'places',
  Countries = 'countries',
  SystemUsers = 'systemUsers',
  PromoCampaigns = 'promoCampaigns',
  PromoCodes = 'promoCodes',
  ActivationCodes = 'activationCodes',
  Calculator = 'calculator',
  Activities = 'activities',
  PartnerCodes = 'partnerCodes',
  InvitedFriends = 'invitedFriends',
  InAppNotifications = 'notifications',
}
